<template>
  <div class="options-wrapper col-12 p-0">
    <div class="options-title">{{ t('prescription.table.options.title') }}</div>
    <table>
      <thead>
      <tr>
        <th></th>
        <th>{{ t('prescription.far') }}</th>
        <th>{{ t('prescription.close') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td class="title">{{ t('prescription.right') }}</td>
        <td v-if="prescriptionData.far.right">
          <div v-for="(option, key) in prescriptionData.far.right" :key="'far-right-' + key">
            <span>{{ key }}: </span>
            <span v-if="key === 'sph' || key === 'cyl'">{{ formatOption(option) }}</span>
            <span v-else>{{ option }}</span>
          </div>
        </td>
        <td v-if="prescriptionData.close.right">
          <div v-for="(option, key) in prescriptionData.close.right" :key="'close-right-' + key">
            <span>{{ key }}: </span>
            <span v-if="key === 'sph' || key === 'cyl'">{{ formatOption(option) }}</span>
            <span v-else>{{ option }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td class="title">{{ t('prescription.left') }}</td>
        <td v-if="prescriptionData.far.left">
          <div v-for="(option, key) in prescriptionData.far.left" :key="'far-left-' + key">
            <span>{{ key }}: </span>
            <span v-if="key === 'sph' || key === 'cyl'">{{ formatOption(option) }}</span>
            <span v-else>{{ option }}</span>
          </div>
        </td>
        <td v-if="prescriptionData.close.left">
          <div v-for="(option, key) in prescriptionData.close.left" :key="'close-left-' + key">
            <span>{{ key }}: </span>
            <span v-if="key === 'sph' || key === 'cyl'">{{ formatOption(option) }}</span>
            <span v-else>{{ option }}</span>
          </div>
        </td>
      </tr>

      <tr>
        <td class="title">{{ t('pd.right') }}</td>
        <td v-if="prescriptionData.far.right.pd">
          <div v-for="(option, key) in prescriptionData.far.right.pd" :key="'far-right-' + key">
            <span>{{ key }}: </span>{{ option }}
          </div>
        </td>
        <td v-if="prescriptionData.close.right.pd">
          <div v-for="(option, key) in prescriptionData.close.right.pd" :key="'close-right-' + key">
            <span>{{ key }}: </span>{{ option }}
          </div>
        </td>
      </tr>
      <tr>
        <td class="title">{{ t('pd.left') }}</td>
        <td v-if="prescriptionData.far.left.pd">
          <div v-for="(option, key) in prescriptionData.far.left.pd" :key="'far-left-' + key">
            <span>{{ key }}: </span>{{ option }}
          </div>
        </td>
        <td v-if="prescriptionData.close.left.pd">
          <div v-for="(option, key) in prescriptionData.close.left.pd" :key="'close-left-' + key">
            <span>{{ key }}: </span>{{ option }}
          </div>
        </td>
      </tr>
      <tr>
        <th>{{ t('prescription.addition.title') }}</th>
        <th>{{ t('birthday.date') }}</th>
      </tr>
      <tr>
        <td v-if="prescriptionData.addition">
          {{ prescriptionData.addition }}
        </td>
        <td v-if="prescriptionData.birthdayDate">
          {{ prescriptionData.birthdayDate }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PrescriptionTableCart',
  props: {
    prescriptionData: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatOption (option) {
      const formattedNumber = parseFloat(option).toFixed(2)
      if (formattedNumber === '0.00') {
        return '0'
      }
      return formattedNumber > 0 ? `+${formattedNumber}` : formattedNumber
    }
  }
}
</script>

<style scoped>

.options-wrapper {
  margin: 20px 0;
}

.options-title {
  font-weight: bold;
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

.title {
  font-weight: bold;
}
</style>
